module.exports = __webpack_public_path__ + "media/images/iconSocialFacebook__errorRed-bef1dd9b85f3a705523ff32c4e3865c7.png";